"use client";

import { Page } from "@/app/components/Page";
import Dashboard from "./dashboard/page";

export default function App() {
  return (
    <Page authenticated={true}>
      <Dashboard />
    </Page>
  );
}
